import React, { useEffect } from "react";
import { useAppStore } from "../../common/app.store.consumer";
import { addScripts } from "../../utils/resources.utils";
import { CIHComponent } from "../types/CIH.component";

const CIHHeader: React.FC<CIHComponent> = useAppStore()((props: CIHComponent) => {
	const store = props.appStore.layoutStore;
	const divRef = React.createRef<HTMLDivElement>();

	useEffect(() => {
		if (store.isLayoutLoaded && !store.areScriptsAdded) {			
			addScripts([store.scriptPluginsURL, store.scriptUrl]);
			store.setAreScriptsAdded(true);
		}
	}, [store, store.isLayoutLoaded, store.scriptPluginsURL, store.scriptUrl]);

	const configuration = props.appStore.configuration;
	useEffect(() => {
		if (divRef.current) {
			divRef.current.addEventListener("click", (e) => {
				const target = e.target as HTMLButtonElement;
				if (target?.id === "OpenIdConnect" && configuration.isOpenIdLoginEnabled) {
					window.location.href = configuration.openIdLoginUrl;
				}
			});
		}
	}, [divRef, configuration]);	

	if (!store.isLayoutLoaded) {
		return null;
	}

	return <div className="cih-hide-print" dangerouslySetInnerHTML={store.CIHHeaderMarkup} ref={divRef} />;
});

export default CIHHeader;
